import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import XCircleblack from "../../IconComponents/XCircleblack";
import {
  postDataWithBody,
} from "../../../Services/Services";
import {
  CancelSopTask,
} from "../../../Services/EndPoints"; // Make sure this endpoint is defined in your EndPoints file
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const TaskModalWithCommentSopCancel = (props) => {
  const {
    titleValue,
    show,
    setShowPop,
    taskData,
  } = props;
  
  const [comment, setComment] = useState(""); 
  const [error, setError] = useState("");
  const navigate = useNavigate();

  // Function to validate the comment length
  const validateCommentLength = () => {
    if (comment.length > 250) {
      setError("Maximum 250 characters are allowed.");
      return false;
    }
    if (comment.length === 0) {
      setError("Please enter a reason for cancellation.");
      return false;
    }
    setError("");
    return true;
  };

  // Handle comment change and validation
  const handleCommentChange = (e) => {
    setComment(e.target.value);
    // Clear error if user starts typing
    if (e.target.value.length > 0 && e.target.value.length <= 255) {
      setError("");
    }
  };

  const handleClose = () => {
    setShowPop(false);
  };

  async function saveConfigData() {
    if (!validateCommentLength()) {
      return;
    }
  
    try {
      const input = {
        sop_instance_id: taskData.id || taskData.id,
        // task_id: taskData.id,
        cancel_reason: comment // Adding the cancellation reason
      };
      
      
      const res = await postDataWithBody(CancelSopTask, input, {});
  
      if (res && res.status === "success") {
        toast.success("SOP instance cancelled successfully", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 2000,
        });
        setShowPop(false);
        navigate("../Sop-instance-list"); // Navigate back to the list after successful cancellation
      } else {
        toast.error(res?.msg || "Failed to cancel SOP instance", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 2000,
        });
      }
    } catch (error) {
      console.error("Error cancelling SOP instance:", error);
      toast.error("An error occurred while cancelling the SOP instance", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
      });
    }
  }

  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        className="table__modal__popup"
        centered
      >
        <Modal.Header>
          <Modal.Title>
            {titleValue || "Cancel SOP Instance"}
          </Modal.Title>
          <XCircleblack
            className="cursor-pointer"
            onClick={handleClose}
            width="1.5em"
            height="1.5em"
          />
        </Modal.Header>
        <Modal.Body>
          <div className="create__resource--popup">
            <div className="form-group">
              <div className="mb-3">
                <label className="label_txt mb-2">
                  Please provide a reason for cancellation:
                </label>
              </div>
              <textarea
                type="text"
                placeholder="Enter cancellation reason"
                className="form-control"
                id="modal_comment_txt_area"
                value={comment}
                onChange={handleCommentChange}
                rows={4}
              />
              {error && <div className="text-danger mt-2">{error}</div>}
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            onClick={handleClose}
            type="button"
            className="btn btn-secondary"
          >
            Cancel
          </button>
          <button
            onClick={saveConfigData}
            type="button"
            className="btn btn-success"
            style={{ backgroundColor: "#1a7a73" }}
            disabled={comment.length === 0 || comment.length > 255}
          >
            Save
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default TaskModalWithCommentSopCancel;